<template>
    <div>
        <h2 class="text-center mb-3">เพิ่มรายการ</h2>

        <!-- Product select -->
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize"
                >สินค้า</label
            >
            <div class="col-sm-8">
                <multiselect
                    v-model="form.product"
                    :options="optionProduct"
                    track-by="code"
                    label="code"
                    placeholder="โปรดเลือกรายการสินค้า"
                    @input="onSelectProduct">
                </multiselect>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize"
                >ชื่อสินค้า</label
            >
            <div class="col-sm-8">
                <input class="form-control" v-model="form.product_name" />
            </div>
        </div>
        <!-- Quantity -->
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize">จำนวน</label>
            <div class="col-sm-8">
                <input
                    type="number"
                    class="form-control"
                    min="1"
                    placeholder="จำนวน"
                    v-model="form.quantity"
                />
            </div>
        </div>

        <!-- Price -->
        <div class="form-group row">
            <label class="col-sm-4 col-form-label text-capitalize"
                >ราคา/หน่วย</label
            >
            <div class="col-sm-8">
                <input
                    type="number"
                    class="form-control"
                    min="0"
                    placeholder="ราคา/หน่วย"
                    v-model="form.price"
                />
            </div>
        </div>

        <div class="text-right">
            <button
                class="btn btn-primary"
                :disabled="!form.product"
                @click="submitAddProduct"
            >
                <icon name="plus"></icon> เพิ่มรายการ
            </button>
        </div>
        <!-- <pre class="alert alert-primary">{{ products }}</pre> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "select-product",
    components: { Multiselect },
    created() {
        this.$store.dispatch("Products/setProducts").then(() => {
            this.products.forEach(product => {
                this.optionProduct.push(product);
            });
        });
    },
    computed: {
        ...mapState({
            products: state => {
                return state.Products.data;
            }
            // products: (state) => {
            //     return [
            //         ...state.Products.data.map(product => ({
            //             value: product,
            //             text: product.code
            //         }))
            //     ];
            // },
        })
    },
    data() {
        return {
            form: {
                product: null,
                product_name: "",
                quantity: 1,
                price: 0
            },
            optionProduct: []
        };
    },
    methods: {
        onSelectProduct(product) {
            this.form.product_name = product.name;
            this.form.price = product.price;
        },
        submitAddProduct() {
            this.$emit("submit", this.form);
        }
    }
};
</script>
